import { AccountTankDueSummary, TankMaintenanceDueStatus } from '../types/interfaces/accountTankMaintenance.interfaces';

/** Local calendar days from today until the due date (matches the date shown in the UI). */
export const getDaysUntilDue = (nextDueDate?: string | Date | null): number | undefined => {
  if (!nextDueDate) {
    return undefined;
  }

  const due = new Date(nextDueDate);
  if (Number.isNaN(due.getTime()) || due.getFullYear() < 1900) {
    return undefined;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  due.setHours(0, 0, 0, 0);
  return Math.round((due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
};

/** Store a date-picker value as UTC midnight of the selected local calendar day (avoids TZ day-shift). */
export const toUtcDateOnlyIso = (date: Date): string => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString();
};

export const getDueStatusFromDays = (daysUntilDue: number): TankMaintenanceDueStatus => {
  if (daysUntilDue < 0) {
    return 'overdue';
  }
  return 'due';
};

export const getDueStatusFromNextDueDate = (
  nextDueDate?: string | null,
  reminderAdvanceDays = 3,
  isEnabled = true,
): TankMaintenanceDueStatus => {
  if (!isEnabled || !nextDueDate) {
    return 'disabled';
  }

  const daysUntilDue = getDaysUntilDue(nextDueDate);
  if (daysUntilDue === undefined) {
    return 'disabled';
  }

  if (daysUntilDue < 0) {
    return 'overdue';
  }
  if (daysUntilDue <= reminderAdvanceDays) {
    return 'due';
  }
  return 'ok';
};

export const buildDueSummaryMap = (dueList: AccountTankDueSummary[]): Map<number, AccountTankDueSummary> => {
  return new Map(dueList.map(item => [item.accountStorageTankId, item]));
};
